import { number, object, string, } from 'yup';
const schemaDefinition = {
    amount: number()
        .required('This field is required')
        .max(1000, 'Maximum of £1000')
        .min(5, 'Minimum of £5'),
    to: string().required('This field is required').email('Please enter a valid email'),
    from: string().required('This field is required'),
    unformattedDeliveryDate: string(),
    message: string(),
};
export const voucherFormSchema = object(schemaDefinition);
